exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".position-box[data-v-53eef0e1]{background:#f6f6f6;padding-bottom:10px}.position-box>.hostory[data-v-53eef0e1]{height:85px;padding:15px 10px 0;box-sizing:border-box}.position-box>.hostory>p[data-v-53eef0e1]{line-height:30px;color:#847d7d}.position-box>.hostory>.citybox[data-v-53eef0e1]{height:40px;box-sizing:border-box;padding-top:5px}.position-box>.hostory>.citybox>button[data-v-53eef0e1]{box-sizing:border-box;border-radius:4px;height:30px;margin:0;background:#fdfdfd;color:#666;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;display:flex;flex-direction:row;justify-content:center;align-items:center;outline:none;border:none}.position-box>.hostory>.citybox>button>.icon[data-v-53eef0e1]{color:#119dfc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53eef0e1","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/PositionBox.vue
// module id = 33
// module chunks = 0